var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/mic_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 13.75C18.75 15.825 17.075 17.5 15 17.5C12.925 17.5 11.25 15.825 11.25 13.75V6.25C11.25 4.175 12.925 2.5 15 2.5C17.075 2.5 18.75 4.175 18.75 6.25V13.75ZM15 20C18.45 20 21.25 17.2 21.25 13.75H23.75C23.75 18.1625 20.4875 21.7875 16.25 22.4V26.25H13.75V22.4C9.5125 21.7875 6.25 18.1625 6.25 13.75H8.75C8.75 17.2 11.55 20 15 20Z",
    fill: "#E3E3E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic24Px);
export default __webpack_public_path__ + "static/media/mic_24px.edce69a82d371dfa84f7895b2afe5314.svg";
export { ForwardRef as ReactComponent };